import { render } from "./NotaryQ.vue?vue&type=template&id=3f8ce44c"
import script from "./NotaryQ.vue?vue&type=script&lang=js"
export * from "./NotaryQ.vue?vue&type=script&lang=js"

import "./NotaryQ.vue?vue&type=style&index=0&id=3f8ce44c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Functional/NotaryQ.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f8ce44c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f8ce44c', __exports__)) {
    api.reload('3f8ce44c', __exports__)
  }
  
  module.hot.accept("./NotaryQ.vue?vue&type=template&id=3f8ce44c", () => {
    api.rerender('3f8ce44c', render)
  })

}


export default __exports__